import React, { useEffect } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import Affix from "../../../../../../components/affix";
import Header from "../../../../../../components/header";
import { useIntl, FormattedMessage } from "react-intl";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useMemo } from "react";
import { trim } from "lodash";
import ConfigConfirm from "../../../../../../components/alert/config-confirm";

const ProcessPoints = props =>{
    const { commentsList, commentRules, sizeInfomation, pointsTotalNum } = props;

    const getPointsSum = useMemo(() =>{
        let sum1 = commentsList?.reduce((initNum, item) =>{
            let content = trim(item?.content);
            if(content?.length >= commentRules?.limitWords){
                initNum += commentRules?.commentScore;
            }

            if(item?.images?.length > 0){
                initNum += commentRules?.uploadImageScore;
            }

            return initNum;
        }, 0);

        let sum2 = Object.keys(sizeInfomation).some(key => !!sizeInfomation[key]) ? commentRules?.sizeInfoScore : 0;

        return sum1 + sum2 || 0;
    }, [commentsList, commentRules, sizeInfomation]);

    

    const getProcessCount = useMemo(() =>{
        return Math.floor(((getPointsSum) / pointsTotalNum) * 100) || 0;
    }, [getPointsSum, pointsTotalNum]);

    return <div className={cls.ProcessPoints}>
        <div className={cls.Hd}>
            <span><FormattedMessage id="points" defaultMessage="Points" /></span>
            <span className={cls.Font1}>{getPointsSum}</span>
            <span>/{pointsTotalNum}</span>
        </div>

        <div className={cls.Content}>
            <span style={{width:`${getProcessCount}%`}}></span>
        </div>

        <div className={cls.Fd}>
            <FormattedMessage id="please_check_rules" defaultMessage="Please check the rules page for text and picture points rules" />
        </div>
    </div>
}

const ReviewHeader = props =>{
    const { commentsList, orderReview, orderDetail, commentRules, sizeInfomation } = props;
    const Intl = useIntl();
    const history = useHistory();

    const pointsTotalNum = useMemo(() =>{
        let length = orderDetail?.orderItems?.length;
        if(length > 0 && commentRules){
            let commentsItemPoints = parseInt(commentRules?.commentScore) + parseInt(commentRules?.uploadImageScore);
            return length * commentsItemPoints + parseInt(commentRules?.sizeInfoScore);
        }

        return 0;
    }, [orderDetail, commentRules]);

    const handleClose = useCallback(() =>{
        if(orderReview?.comments?.length > 0){
            history.goBack();
        }else{
            ConfigConfirm({
                close:{
                },
                message:{
                    text:`${Intl.formatMessage({ id: "dont_want_rate", defaultMessage: "Sure you don\'t want to rate this order? You will receive " })} <span style="color:#e64545;">${pointsTotalNum}</span> ${Intl.formatMessage({ id: "points", defaultMessage: "points" })}`,
                    style:{},
                    html:true
                },
                btn1:{
                    text: Intl.formatMessage({ id: "no_thanks", defaultMessage: "No Thanks" }),
                    style:{},
                    clickHandle:() =>{
                        history.goBack();
                    }
                },
                btn2:{
                    text: Intl.formatMessage({ id: "to_review", defaultMessage: "To Review" }),
                }
            });
        }
    }, [pointsTotalNum]);

    return <div className={cls.ReviewHeader}>
        <Header 
            centerSlot={Intl.formatMessage({id: 'review', defaultMessage: 'Review'})} 
            onClose={handleClose}
        />

        <ProcessPoints pointsTotalNum={pointsTotalNum} commentsList={commentsList} commentRules={commentRules} sizeInfomation={sizeInfomation} />
    </div>
}


export default props =>{
    useStyles(cls);

    return <Affix offsetTop={0}>
        <ReviewHeader {...props} />
    </Affix>
}